import React, { useEffect } from "react";

const SingleTemplate = (props) => {
  // const [id, setId] = useState(props.id);
  const playMovie = (e) => {
    e.target.play();
    e.target.muted = true;
  };

  const stopMovie = (e) => {
    e.target.pause();
    e.target.load();
  };

  const makeFav = (e, temp_id, fav) => {
    e.preventDefault();
    props.makeIsfav(temp_id, fav);
  };

  useEffect(() => {

    var getKeyword = localStorage.getItem('keyword');

    if( getKeyword !== null ){
      getKeyword = getKeyword.replace(/['"]+/g, '');
      //convert lowercase
      getKeyword = getKeyword.toLowerCase();
    }
    // if( props.name.includes('dental') || props.main_temp_id === 131){
    if( props.name.toLowerCase().includes(getKeyword) ){
      props.templateId(props.main_temp_id, true);
      console.log(props.main_temp_id)
      //clear localstorage if keyword found
      if( getKeyword ){
        // localStorage.removeItem('keyword');
      }

    }

    // eslint-disable-next-line 
  }, []);


  // console.log(props.template_type);

  return (
    <div className="col-xl-4 col-lg-4 col-md-4" key={props.id}>
      <div
        className={`vd_cl ${
          props.selectedTemp === props.main_temp_id ? "selected" : ""
        }`}
      >
        <div
          className="series_vd position-relative cursor"
          onClick={(e) => {
            props.templateId(props.main_temp_id);
          }}
          style={{ backgroundColor:'#bbbbbb', borderRadius: '10px 10px 0px 0px', height: '220px' }}
        >
          <video
            src={props.preview_url}
            poster={props.thumbnail_url}
            //   preload="none"
            loop
            width="100%"
            height="220px"
            onMouseOver={playMovie}
            onMouseOut={stopMovie}
            // className="no-coursor"
            // className="cursor"
            className={ (props.template_type && props.template_type === 'Vertical') ? "select_campignImage_vertical" : (props.template_type && props.template_type === 'Box') ? "select_campignImage_box" : (props.template_type && props.template_type === 'Wide') ? "select_campignImage_wide" :"select_campignImage_fhd" }
            
          />
        </div>
        <div className="bdy_vd position-relative">
          <div className="like_btn">
            <a
              href="#0"
              className={props.is_fav !== 0 && props.is_fav > 0 ? "active" : ""}
              onClick={(e) => {
                makeFav(e, props.id, props.is_fav);
              }}
              data-toggle="tooltip"
              data-placement="top"
              title={
                props.is_fav !== 0 && props.is_fav > 0
                  ? "Remove From Favourite"
                  : "Add To Favourite"
              }
              data-bs-original-title={
                props.is_fav !== 0 && props.is_fav > 0
                  ? "Remove From Favourite"
                  : "Add To Favourite"
              }
            >
              <i className="fa fa-heart-o"></i>
            </a>
          </div>
          <h4 className="pb-4 pt-4 text-center text-capitalize">
            {props.name}
          </h4>
          <button
            className={`btn btn2 w-100 ${
              props.selectedTemp === props.main_temp_id ? "selected_temp" : ""
            }`}
            onClick={(e) => {
              props.templateId(props.main_temp_id);
            }}
          >
            {props.selectedTemp === props.main_temp_id ? "Selected" : "Select"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default SingleTemplate;
